import { getDataFromTree } from '@apollo/client/react/ssr';
import initApollo from './initApollo';
import { ApolloProvider } from '@apollo/client';

const withApollo = (App) => {
  const Apollo = ({ apolloState, jwt, ssrApolloClient, ...props }) => {
    const apolloClient =
      ssrApolloClient || initApollo({ initialState: apolloState, jwt });

    return (
      <ApolloProvider client={apolloClient}>
        <App {...props} pageProps={{ ...props.pageProps, apolloClient }} />
      </ApolloProvider>
    );
  };

  Apollo.getInitialProps = async (ctx) => {
    const appProps = App.getInitialProps ? await App.getInitialProps(ctx) : {};

    const serverProps = ctx.Component.getServerSideProps
      ? await ctx.Component.getServerSideProps(ctx.ctx)
      : {};

    const jwt =
      ctx.ctx.query.jwt ||
      parseCookies(ctx.ctx.req && ctx.ctx.req.headers.cookie);

    let apolloState;

    if (typeof window === 'undefined') {
      const apolloClient = initApollo({ jwt });

      try {
        await getDataFromTree(
          <ctx.AppTree
            ssrApolloClient={apolloClient}
            pageProps={{
              ...appProps,
              ...serverProps.props,
              Component: ctx.Component
            }}
          />
        );
      } catch (error) {
        console.error('Error while running `getDataFromTree`', error);
      }

      apolloState = apolloClient.cache.extract();
    }

    return {
      ...appProps,
      ...serverProps.props,
      apolloState,
      jwt
    };
  };

  return Apollo;
};

function parseCookies(cookies) {
  if (!cookies) return null;

  const cookie = cookies
    .split('; ')
    .find((item) => item.split('=')[0] === 'jwt');

  return cookie ? cookie.split('=')[1] : null;
}

export default withApollo;
